module.exports = __webpack_public_path__ + "img/banner-siddeti-onleme-ve-insan-haklari-danismanligi.c91615e9.png";